import z from 'zod';

export const progressScoreSchema = z.object({
  /** Topic name */
  topic: z.string(),
  /** Difficulty level (1-5) */
  difficulty: z.number().int().min(1).max(5),
  /** Total number of questions attempted for this topic and difficulty */
  total: z.number().int().min(0),
  /** Number of correctly answered questions for this topic and difficulty */
  correct: z.number().int().min(0),
  /** Historic data of correct/incorrect answers (max 40 items) */
  historicData: z.array(z.boolean()),
  /** Previously answered question IDs for this topic and difficulty (last 500) */
  previousQuestionIds: z.array(z.string()).optional(),
  /** Accuracy ratio (0-1) for this topic and difficulty */
  accuracy: z.number().min(0).max(1),
  /** Adjusted accuracy (0-1) for this topic and difficulty adjusted for insufficient data */
  adjustedAccuracy: z.number().min(0).max(1),
  /** Calculated score (difficulty + adjustedAccuracy) */
  score: z.number(),
});

export type ProgressScore = z.infer<typeof progressScoreSchema>;
